<template>
  <div class="building-search">
    <div class="mobile-heading" v-if="$md.mobile() && !$md.tablet()">
      <div class="mobile-header-container">
        <div class="mobile-title">{{ $t('building_page.PAGE_TITLE') }}</div>
        <div>
          <router-link 
            :to="{ name: 'buildingList' }" 
            :class="['mobile-list-page-button', {'less-spacing':$i18n.locale === 'en'}]"
          >
            <img :src="buildingIcon"></img> {{ $t('building_page.BLDG_LIST_PAGE') }}
          </router-link>
        </div>
      </div>
      <p class="page-description">
      {{ $t('building_page.PAGE_DESCRIPTION') }}
      </p>
      <form class="search-form">
        <div class="row">
          <div class="col-xs-12 selection-box no-pad-left-xs">
            <building-search-input :districtId="districtId" />
          </div>
        </div>
      </form>
    </div>

    <div class="heading" v-else>
      <!-- <search-bar :show-intro="true" :currentPage="currentPage" />  -->

      <page-title>
        <div class="main-title">
          {{ $t('building_page.PAGE_TITLE') }}
          <router-link :to="{ name: 'buildingList' }" class="list-page-button">
            <img :src="buildingIcon"></img> {{ $t('building_page.BLDG_LIST_PAGE') }}
          </router-link>
        </div>

        <p class="page-description">{{ $t('building_page.PAGE_DESCRIPTION') }}</p>

        <form>
          <div class="search-form">
            <div class="selection-box">
              <district-selection v-model="districtId"></district-selection>
            </div>
            <div class="selection-box">
              <building-search-input :districtId="districtId"></building-search-input>
            </div>
          </div>
        </form>
      </page-title>

    </div>
      
  </div>
</template>

<script>
import SearchBar from '@/components/Home/SearchBar';
import PageTitle from '@/components/PageTitle';
import DistrictSelection from '@/components/DistrictSelection';
import BuildingSearchInput from '@/components/BuildingSearchInput';
import buildingIcon from '@/assets/icons/icon_Structure_white.svg';

export default {
  components: {
    SearchBar,
    PageTitle,
    DistrictSelection,
    BuildingSearchInput,
  },
  data () {
    return {
      districtId: null,
      buildingIcon,
    }
  },
  computed: {
    currentPage() {
      return this.$route.name;
    },
  },
};
</script>

<style scoped>
.building-search {
  background: transparent;
  text-align: center;
}

.list-page-button {
  background: #05aecf;
  padding: 0px 10px;
  border-radius: 6px;
  color: #fff;
  font-size: 16px;  
  font-weight: 300;
  display: inline-block;
  vertical-align: top;
  margin: 5px 0px 0px 15px;
}

.heading {
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.main-title {
  margin: 0;
  padding: 0;
  font-size: 35px;
  line-height: 35px;
  font-weight: 500;
  color: #000;
  display: flex;
  justify-content: center;
  align-items: center;
}

.mobile-heading {
  padding: 10px 15px 0 15px;
}
.mobile-title {
  margin: 0px 0px 5px 0px;
  font-size: 23.8px;
  font-weight: 400;
  color: #000000;
  white-space: nowrap;
}

.mobile-header-container {
  display: flex;
  justify-content: space-between;  
}

.mobile-list-page-button {
  background: #05aecf;
  padding: 6px 16px;
  border-radius: 6px;
  color: #fff;
  font-size: 16px;
  line-height: 22.8571px;
  font-weight: 300;
  display: inline-block;
  vertical-align: top;
  display: flex;
  white-space: nowrap;
}
.mobile-list-page-button.less-spacing {
  padding: 6px 4px;
}

.list-page-button img {
  width: 25px;
  vertical-align: text-bottom;
}

.mobile-list-page-button img {
  width: 16px;
  height: 22px;
  vertical-align: text-bottom;
  margin-right: 2px;
}

.page-description {
  font-size: 16px;
}

.selection-box {  
  min-width: 350px;
  max-width: 50%;  
}
.selection-box + .selection-box {
  margin-left: 20px;
}

.search-form {
  display: flex;
  justify-content: center;
}

@media (max-width: 767px) {
  .search-form {
    margin-top: 0;
  }
}
</style>